(() => {
  const wrapper = document.querySelector('.tpu-cart-page__wrapper');
  if (!wrapper) return;

  const couponInput = wrapper.querySelector('[data-tpu-cart-coupon-input]');
  const couponApply = wrapper.querySelector('[data-tpu-cart-coupon-apply]');
  const countEl = wrapper.querySelector('[data-tpu-cart-count]');
  const itemsOne = wrapper.dataset.i18nItemsOne || '[count] item in your cart';
  const itemsOther = wrapper.dataset.i18nItemsOther || '[count] items in your cart';
  const qtyMaxOne = wrapper.dataset.i18nQtyMaxOne || 'Only [count] item available in stock.';
  const qtyMaxOther = wrapper.dataset.i18nQtyMaxOther || 'Only [count] items available in stock.';
  const qtyErrorGeneric = wrapper.dataset.i18nQtyErrorGeneric || 'This quantity is not available.';
  const pendingQtyErrors = new Map();
  const paypalCart = wrapper.querySelector('[data-tpu-paypal-cart]');

  const paypalTextSize = () => window.innerWidth >= 768 ? '13' : '15';
  const syncPaypalCart = (cart) => {
    if (!paypalCart) return;
    const total = Number(cart?.total_price);
    const count = Number(cart?.item_count);
    if (!Number.isFinite(total) || total <= 0 || count === 0) {
      paypalCart.replaceChildren();
      return;
    }
    const message = document.createElement('div');
    message.setAttribute('data-pp-message', '');
    message.setAttribute('data-pp-placement', 'cart');
    message.setAttribute('data-pp-amount', (total / 100).toFixed(2));
    message.setAttribute('data-pp-style-layout', 'text');
    message.setAttribute('data-pp-style-logo-type', 'inline');
    message.setAttribute('data-pp-style-text-color', 'black');
    message.setAttribute('data-pp-style-text-size', paypalTextSize());
    paypalCart.replaceChildren(message);
  };
  const mobileAccordionMq = window.matchMedia('(max-width: 1023px)');
  const desktopAccordionMq = window.matchMedia('(min-width: 1024px)');
  const accordionsRoot = wrapper.querySelector('.tpu-cart-page__accordions');
  const sidebar = wrapper.querySelector('.tpu-cart-page__sidebar');

  const revealAccordionInSidebar = (details) => {
    if (!sidebar || !details.open) return;

    const summary = details.querySelector('.tpu-cart-page__accordion-summary');
    const body = details.querySelector('.tpu-cart-page__accordion-body');
    if (!summary || !body) return;

    const sidebarRect = sidebar.getBoundingClientRect();
    const bodyRect = body.getBoundingClientRect();
    const summaryRect = summary.getBoundingClientRect();

    if (bodyRect.bottom > sidebarRect.bottom) {
      sidebar.scrollTop += bodyRect.bottom - sidebarRect.bottom + 8;
    } else if (summaryRect.top < sidebarRect.top) {
      sidebar.scrollTop -= sidebarRect.top - summaryRect.top + 8;
    }
  };

  const bindExclusiveAccordions = () => {
    if (!accordionsRoot) return;

    accordionsRoot.querySelectorAll('.tpu-cart-page__accordion').forEach((details) => {
      if (details.dataset.tpuAccordionBound) return;
      details.dataset.tpuAccordionBound = 'true';

      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', () => {
          if (desktopAccordionMq.matches) {
            details.dataset.tpuPreserveScrollY = String(window.scrollY);
          }
        });
      }

      details.addEventListener('toggle', () => {
        if (!details.open) return;

        if (mobileAccordionMq.matches) {
          accordionsRoot.querySelectorAll('.tpu-cart-page__accordion').forEach((other) => {
            if (other !== details) other.open = false;
          });
          return;
        }

        if (!desktopAccordionMq.matches) return;

        accordionsRoot.querySelectorAll('.tpu-cart-page__accordion').forEach((other) => {
          if (other !== details) other.open = false;
        });

        const preservedScrollY = Number.parseFloat(details.dataset.tpuPreserveScrollY || '');
        const scrollY = Number.isFinite(preservedScrollY) ? preservedScrollY : window.scrollY;

        requestAnimationFrame(() => {
          window.scrollTo(0, scrollY);
          revealAccordionInSidebar(details);

          const focusTarget = details.querySelector('input, textarea');
          if (focusTarget) {
            try {
              focusTarget.focus({ preventScroll: true });
            } catch (_error) {
              focusTarget.focus();
            }
          }
        });
      });
    });
  };

  const formatCount = (count) => {
    const safeCount = Number.isFinite(count) ? count : 0;
    const template = safeCount === 1 ? itemsOne : itemsOther;
    return template.replace(/\[count\]/g, String(safeCount));
  };

  const formatQtyMaxError = (max) => {
    const template = max === 1 ? qtyMaxOne : qtyMaxOther;
    return template.replace(/\[count\]/g, String(max));
  };

  const showQtyError = (lineItem, message) => {
    const lineId = lineItem?.dataset?.key;
    if (lineId) pendingQtyErrors.set(lineId, message);

    const errorEl = lineItem?.querySelector('[data-tpu-cart-qty-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  };

  const clearQtyError = (lineItem) => {
    const lineId = lineItem?.dataset?.key;
    if (lineId) pendingQtyErrors.delete(lineId);

    const errorEl = lineItem?.querySelector('[data-tpu-cart-qty-error]');
    if (errorEl) errorEl.hidden = true;
  };

  const reapplyPendingQtyErrors = () => {
    if (!pendingQtyErrors.size) return;

    pendingQtyErrors.forEach((message, lineId) => {
      const lineItem = wrapper.querySelector(`cart-line-item[data-key="${CSS.escape(lineId)}"]`);
      if (!lineItem) return;
      showQtyError(lineItem, message);
    });
  };

  const syncQtyChange = (lineItem, qtyInput, lineId, requestedQty) => {
    const input = qtyInput.querySelector("input[name='quantity']");
    const previousQty = input ? input.value : requestedQty;
    const max = input?.max ? parseInt(input.max, 10) : null;
    let qtyToSet = requestedQty;
    let showMaxError = false;

    if (max && requestedQty > max) {
      qtyToSet = max;
      showMaxError = true;
      if (input) input.value = String(max);
    }

    if (!window.Cart) return Promise.resolve();

    return window.Cart.change(lineId, qtyToSet)
      .then((res) => {
        if (!res?.items) throw res;

        const item = res.items.find((cartItem) => cartItem.key === lineId);
        const totalPriceEl = lineItem.querySelector('.js-total-price');

        if (item) {
          if (totalPriceEl && typeof item.final_line_price === 'number' && typeof item.final_line_price.toCurrency === 'function') {
            totalPriceEl.innerHTML = item.final_line_price.toCurrency();
          }
          if (input) input.value = item.quantity;

          if (showMaxError || requestedQty > item.quantity) {
            const cap = max || item.quantity;
            showQtyError(lineItem, formatQtyMaxError(cap));
          } else {
            clearQtyError(lineItem);
          }
        }

        document.dispatchEvent(new CustomEvent('cart-change', { detail: res }));
      })
      .catch((err) => {
        const message = err?.description || err?.message || qtyErrorGeneric;
        showQtyError(lineItem, message);

        return window.Cart.get().then((cart) => {
          const item = cart.items.find((cartItem) => cartItem.key === lineId);
          if (item && input) {
            input.value = item.quantity;
          } else if (input) {
            input.value = previousQty;
          }
        });
      });
  };

  const bindQuantityInputs = () => {
    wrapper.querySelectorAll('cart-line-item .tpu-cart-qty quantity-input').forEach((qtyInput) => {
      if (qtyInput.dataset.tpuBound) return;
      qtyInput.dataset.tpuBound = 'true';

      const lineItem = qtyInput.closest('cart-line-item');
      const lineId = lineItem?.dataset?.key;
      if (!lineId) return;

      const bindChange = () => {
        qtyInput.addEventListener('click', (event) => {
          if (!event.target.closest('quantity-input-plus')) return;

          const input = qtyInput.querySelector("input[name='quantity']");
          if (!input?.max) return;

          const max = parseInt(input.max, 10);
          const current = parseInt(input.value, 10) || 0;
          if (current >= max) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showQtyError(lineItem, formatQtyMaxError(max));
          }
        }, true);

        qtyInput.onChange((quantity) => {
          const qty = parseInt(quantity, 10);
          if (!qty || qty < 1) return;
          syncQtyChange(lineItem, qtyInput, lineId, qty);
        });
      };

      if (customElements.get('quantity-input')) {
        bindChange();
      } else {
        customElements.whenDefined('quantity-input').then(bindChange);
      }
    });
  };

  const syncCartSections = async () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const shippingSlot = wrapper.querySelector('[data-tpu-cart-page-shipping]');

    try {
      const response = await fetch(`${root}cart?sections=cart-template,ajax-cart`);
      if (!response.ok) return;

      const data = await response.json();
      const sectionHtml = data['cart-template'];
      const ajaxCartHtml = data['ajax-cart'];

      if (sectionHtml) {
        const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const currentItems = wrapper.querySelectorAll('cart-line-item[data-key]');

        currentItems.forEach((item) => {
          const key = item.dataset.key;
          const source = doc.querySelector(`cart-line-item[data-key="${CSS.escape(key)}"]`);
          if (!source) return;

          if (source.dataset.bulk) {
            item.dataset.bulk = source.dataset.bulk;
          }

          const targetStock = item.querySelector('[data-tpu-stock]');
          const sourceStock = source.querySelector('[data-tpu-stock]');

          if (targetStock && sourceStock) {
            targetStock.dataset.tpuStockStatus = sourceStock.dataset.tpuStockStatus || '';
            targetStock.innerHTML = sourceStock.innerHTML;
          } else if (targetStock && !sourceStock) {
            targetStock.remove();
          }

          item.querySelectorAll('[data-tpu-price-stack]').forEach((targetStack, index) => {
            const sourceStacks = source.querySelectorAll('[data-tpu-price-stack]');
            const sourceStack = sourceStacks[index];
            if (sourceStack) {
              targetStack.innerHTML = sourceStack.innerHTML;
            }
          });

          const sourceTotal = source.querySelector('.js-total-price');
          const targetTotal = item.querySelector('.js-total-price');
          if (sourceTotal && targetTotal) {
            targetTotal.innerHTML = sourceTotal.innerHTML;
          }

          const sourceInput = source.querySelector('input[name="quantity"]');
          const targetInput = item.querySelector('input[name="quantity"]');
          if (sourceInput && targetInput && sourceInput.max) {
            targetInput.max = sourceInput.max;
          }
        });
      }

      if (ajaxCartHtml && shippingSlot) {
        const ajaxDoc = new DOMParser().parseFromString(ajaxCartHtml, 'text/html');
        const shippingBanner = ajaxDoc.querySelector('[data-fragment="shipping-banner"]');
        shippingSlot.innerHTML = shippingBanner ? shippingBanner.innerHTML : '';
      }

      reapplyPendingQtyErrors();
    } catch (_error) {
      // Section refresh is best-effort; cart totals still update via cart-page.js
    }
  };

  if (countEl) {
    const initialCount = parseInt(wrapper.dataset.status || '0', 10);
    countEl.textContent = formatCount(initialCount);
  }

  document.addEventListener('cart-change', (event) => {
    const detail = event.detail || {};
    syncPaypalCart(detail);
    if (typeof detail.item_count === 'number' && countEl) {
      countEl.textContent = formatCount(detail.item_count);
    }
    syncCartSections();
  });

  document.addEventListener('cart-remove', (event) => {
    const detail = event.detail || {};
    syncPaypalCart(detail);
    const lineId = detail.key;
    if (lineId) pendingQtyErrors.delete(lineId);

    if (typeof detail.item_count === 'number' && countEl) {
      countEl.textContent = formatCount(detail.item_count);
    }
    syncCartSections();
  });

  if (couponApply && couponInput) {
    couponApply.addEventListener('click', () => {
      const code = couponInput.value.trim();
      if (!code) return;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cartUrl = `${root}cart`;
      window.location.href = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartUrl)}`;
    });
  }

  customElements.whenDefined('cart-line-item').then(() => {
    bindQuantityInputs();
    requestAnimationFrame(bindQuantityInputs);
  });

  if (customElements.get('cart-line-item')) {
    bindQuantityInputs();
    requestAnimationFrame(bindQuantityInputs);
  }

  bindExclusiveAccordions();
})();
